import { type Rule } from "antd/lib/form"
import moment from "moment"
import { i18n } from "~Shared/locales/i18n"

export const createArchiveSearchRules = ({ isFinwayAdmin }: { isFinwayAdmin: boolean }) => ({
    period: [
        {
            validator: (_rule, value: [moment.Moment, moment.Moment]) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (Math.abs(value[0].diff(value[1], "months")) > 6) {
                    // only for performance testing
                    if (isFinwayAdmin) {
                        return Promise.resolve()
                    }
                    return Promise.reject(i18n.t("validation:period_too_long"))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
